/**
 * External Links Section for Assistant Profile
 * Handles portfolio website, Instagram, Facebook, and TikTok links
 */
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ExternalLinksSection({
  portfolioLink,
  setPortfolioLink,
  instagramHandle,
  setInstagramHandle,
  facebookUrl,
  setFacebookUrl,
  tiktokHandle,
  setTiktokHandle
}) {
  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-6">External Links</h2>
      
      <div className="space-y-4">
        <div>
          <Label className="text-sm text-white/60 uppercase tracking-wider">Portfolio Website</Label>
          <Input
            value={portfolioLink}
            onChange={(e) => setPortfolioLink(e.target.value)}
            placeholder="https://yourportfolio.com"
            className="mt-2 bg-white/[0.05] border-white/10 focus:border-white/40 text-white h-12 rounded-sm"
            data-testid="portfolio-link-input"
          />
        </div>
        <div>
          <Label className="text-sm text-white/60 uppercase tracking-wider">Instagram Handle</Label>
          <div className="relative mt-2">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-white/30">@</span>
            <Input
              value={instagramHandle}
              onChange={(e) => setInstagramHandle(e.target.value)}
              placeholder="yourhandle"
              className="bg-white/[0.05] border-white/10 focus:border-white/40 text-white pl-8 h-12 rounded-sm"
              data-testid="instagram-handle-input"
            />
          </div>
        </div>
        <div>
          <Label className="text-sm text-white/60 uppercase tracking-wider">TikTok Handle</Label>
          <div className="relative mt-2">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-white/30">@</span>
            <Input
              value={tiktokHandle}
              onChange={(e) => setTiktokHandle(e.target.value)}
              placeholder="yourhandle"
              className="bg-white/[0.05] border-white/10 focus:border-white/40 text-white pl-8 h-12 rounded-sm"
              data-testid="tiktok-handle-input"
            />
          </div>
        </div>
        <div>
          <Label className="text-sm text-white/60 uppercase tracking-wider">Facebook Page</Label>
          <Input
            value={facebookUrl}
            onChange={(e) => setFacebookUrl(e.target.value)}
            placeholder="https://facebook.com/yourpage"
            className="mt-2 bg-white/[0.05] border-white/10 focus:border-white/40 text-white h-12 rounded-sm"
            data-testid="facebook-url-input"
          />
        </div>
      </div>
    </Card>
  );
}
